import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import SdvPlanModal from "../SdvPlan/SdvPlanModal.vue";
import GenericApproveRejectModal from "../GenericApproveRejectModal/GenericApproveRejectModal.vue";
import ManageSDVRuleList from "../ManageSDVRule/ManageSDVRuleList.vue";

export default {
  name: "sdvPlan",
  components: {
    VPagination,
    SdvPlanModal,
    GenericApproveRejectModal,
    ManageSDVRuleList
  },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idToken: store.getters.getIdToken,
      roleprivileges: "",
      studyId: "",
      defaultdate: "",
      showTableLoading: false,
      planList: { entities: [], totalCount: 0 },
      totalPage: 1,
      currentPage: 1,
      showSidePopup: [],
      showPlanModal: false,
      editingPlanId: null,
      searchData: {
        PageNumber: 1,
        PageSize: 10,
        SortBy: "CreatedAt",
        SortOrder: "desc",
        PlanName: "",
        Status: "",
        EffectiveFrom: null,
      },
        showRulesListModal: false,
      rulesPlanId: null,
      rulesPlanVersion: 0,
       rulesPlanStatus: "",
       showApproveRetireModal: false,
    approveRetireContext: {
      heading: "",
      action1Label: "",
      type: "",
      successMsg: "",
      payload: {},
    },
      headerValues: {},
    };
  },

  async mounted() {
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    this.defaultdate = localStorage.getItem("dateformat");

    await this.setroleprivileges();

    window.addEventListener("studyIdChanged", async () => {
      this.studyId = store.getters.getStudyIs;
      this.searchData.PageNumber = 1;
      await this.getSdvPlanList();
    });

    this.studyId = store.getters.getStudyIs;
    await this.getSdvPlanList();
  },

  methods: {
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
      console.log(this.roleprivileges);
    },

    async getSdvPlanList() {
      this.showTableLoading = true;
      try {
        let url = `${this.baseurl}/management/sdv/getsdvplans`
          + `?studyId=${this.studyId}`
          + `&PageNumber=${this.searchData.PageNumber}`
          + `&PageSize=${this.searchData.PageSize}`
          + `&SortBy=${this.searchData.SortBy}`
          + `&SortOrder=${this.searchData.SortOrder}`
          + `&planName=${this.searchData.PlanName || ""}`
          + `&status=${this.searchData.Status || ""}`;

        if (this.searchData.EffectiveFrom) {
          url += `&effectiveFrom=${this.filterDate(this.searchData.EffectiveFrom)}`;
        }

        const res = await axios.get(url, this.headerValues);
        this.showTableLoading = false;
        this.planList = res.data;
        this.showSidePopup = new Array(this.planList.entities.length).fill(false);
        this.totalPage = parseInt(this.planList.totalCount / this.searchData.PageSize);
        if (this.planList.totalCount % this.searchData.PageSize != 0) {
          this.totalPage = this.totalPage + 1;
        }
      } catch (error) {
        this.showTableLoading = false;
        console.error("Error fetching SDV Plan List:", error);
      }
    },

    loadPage(page) {
      this.currentPage = page;
      this.searchData.PageNumber = page;
      this.getSdvPlanList();
    },

    async search() {
      this.searchData.PageNumber = 1;
      await this.getSdvPlanList();
    },

    SortSelected(prop) {
      if (this.searchData.SortBy === prop) {
        this.searchData.SortOrder = this.searchData.SortOrder === "asc" ? "desc" : "asc";
      } else {
        this.searchData.SortBy = prop;
        this.searchData.SortOrder = "asc";
      }
      this.searchData.PageNumber = 1;
      this.currentPage = 1;
      this.getSdvPlanList();
    },

    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate);
      }
    },

    filterDate(data) {
      if (!data) {
        return null;
      }
      return moment(data).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
    },

    statusBadgeClass(status) {
      switch ((status || "").toLowerCase()) {
        case "draft":
          return "badge-draft";
        case "active":
          return "badge-active";
        case "superseded":
          return "badge-superseded";
        case "retired":
          return "badge-retired";
        default:
          return "";
      }
    },

    openCreateModal() {
      this.editingPlanId = null;
      this.showPlanModal = true;
    },

 editPlan(id) {
      this.editingPlanId = id;
      this.showPlanModal = true;
    },

    closePlanModal() {
      this.showPlanModal = false;
      this.editingPlanId = null;
    },

    refreshPlanList() {
      this.getSdvPlanList();
    },

// viewRules(plan) {
//   this.$router.push({
//     path: `/ManageSDVRuleList/${plan.id}`,
//     query: {
//       planVersion: plan.planVersion
//     }
//   });
// }
// ,

viewRules(plan) {
  // Open the rules list as a modal popup
  this.rulesPlanId = plan.id;
   this.rulesPlanVersion = plan.planVersion || 0;
   this.rulesPlanStatus = plan.status || "";  
  this.showRulesListModal = true;
},

   openApproveModal(plan) {
  this.approveRetireContext = {
    heading: "Approve & Activate SDV Plan",
    action1Label: "Approve & Activate",
    type: "Approval",
    successMsg: "SDV Plan approved and activated successfully.",
    payload: {
      sdvPlanId: plan.id,
      studyId: this.studyId,
      studyVersion: plan.studyVersion,
    },
  };
  this.showApproveRetireModal = true;
},

openRetireModal(plan) {
  this.approveRetireContext = {
    heading: "Retire SDV Plan",
    action1Label: "Retire",
    type: "Retire",
    successMsg: "SDV Plan retired successfully.",
    payload: {
      sdvPlanId: plan.id,
      studyId: this.studyId,
      studyVersion: plan.studyVersion,
    },
  };
  this.showApproveRetireModal = true;
},

  closeApproveRetireModal() {
    this.showApproveRetireModal = false;
  },

  onApproveRetireSuccess() {
    this.showApproveRetireModal = false;
    this.getSdvPlanList();
  },

  onApproveRetireError(payload) {
    console.error("Approve/Retire failed:", payload.error);
    // component already stays open on error since it doesn't auto-close on actionError
  },
closeRulesList() {
  this.showRulesListModal = false;
  this.rulesPlanId = null;
  this.rulesPlanVersion = 0;
   this.rulesPlanStatus = "";  
},
 
  },
};